var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("label", [_vm._v(_vm._s(_vm.$ct("preview-documents")))]),
          _c("app-sale-search-with-browse", {
            attrs: {
              label: _vm.$ct("documents"),
              value: _vm.sale,
              "show-remove-button": "",
              fancy: "",
            },
            on: {
              input: function ($event) {
                return _vm.setSale($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }